import { type FC } from 'react'
import Link from 'next/link'

import { Button, Stack, type StackProps, Typography } from '@mui/material'
import { SuccessIcon2 } from '@core/components/icons'
import { useLayout } from '@core/contexts/layout'
import { colors } from '@core/helpers'

type Props = StackProps & {
  showLoginButton?: boolean
}

export const ChangePasswordSuccessContent: FC<Props> = ({ showLoginButton = true, ...props }) => {
  const { isMobile } = useLayout()

  return (
    <Stack {...props} flex={1} direction='column' justifyContent='center'>
      <Stack component='section' mb={isMobile ? '1.6rem' : '3.2rem'} alignItems='center'>
        <SuccessIcon2 color={colors.primary_light} size={isMobile ? 64 : 80} />
      </Stack>
      <Stack width='100%' alignItems='center' component='section' mb={isMobile ? '3.2rem' : '4rem'}>
        <Typography
          textAlign='center'
          sx={{ color: 'var(--color-primary-darkest)' }}
          variant={isMobile ? 'd3' : 'h1_bold'}
          component='h1'
          maxWidth={isMobile ? '31.2rem' : '39.9rem'}
        >
          Tu contraseña se cambió con éxito
        </Typography>
      </Stack>
      <Stack width='100%' gap='0.8rem'>
        {showLoginButton && (
          <Button
            size='large'
            LinkComponent={Link}
            href='/autenticacion/iniciar-sesion'
            sx={{ width: isMobile ? '21.1rem' : '18.4rem', alignSelf: 'center' }}
          >
            Iniciar sesión
          </Button>
        )}
        <Button
          variant='text'
          size='large'
          LinkComponent={Link}
          href='/'
          sx={{ width: isMobile ? '21.1rem' : '18.4rem', alignSelf: 'center' }}
        >
          Ir a Inicio
        </Button>
      </Stack>
    </Stack>
  )
}
